<template>
	<v-dialog v-model="dialog" width="500">
		<v-card>
			<v-container>
				<v-row>
					<v-col>
						<s-select-assigned 
							:projectID="currentProjectId" 
							full 
							return-object
							label="Transferir a" 
							clearable 
							v-model="datatransfer.assignedUser"
						></s-select-assigned>
					</v-col>
				</v-row>
				<v-row>
					<v-col>
						<s-textarea label="Motivo" v-model="datatransfer.TskReasonTraslate"></s-textarea>
					</v-col>
				</v-row>
				<v-row>
					<v-col>
						<v-btn color="primary" @click="sendTransfer">
							Transferir
						</v-btn>
					</v-col>
					<v-col>
						<v-btn color="warning" @click="cancelTransfer">
							Cancelar
						</v-btn>
					</v-col>
				</v-row>
			</v-container>
		</v-card>
	</v-dialog>
</template>

<script>
import _sTaskService from '@/services/InformationTechnology/TaskService.js';
import _sTaskUsersService from '@/services/InformationTechnology/TaskUsersService.js';
import sTextarea from '@/components/Utils/sTextarea.vue'; // Utilizando el que está en el proyecto
import sSelectAssigned from '@/components/Utils/SSelectAssigned.vue';

export default {
    name: 'TaskWorkerTransferModal',
    components: {
        sTextarea,
        sSelectAssigned
    },
    props: {
        value: {
            type: Boolean,
            default: false
        },
        tasks: {
            type: Array,
            default: () => []
        },
        workers: {
            type: Array,
            default: () => []
        }
    },
    data() {
        return {
            datatransfer: {
                assignedUser: null,
                TskReasonTraslate: ''
            }
        };
    },
    computed: {
        currentProjectId() {
            if (this.tasks && this.tasks.length > 0) {
                return this.tasks[0].TkpID || 0;
            }
            return 0;
        },
        dialog: {
            get() {
                return this.value;
            },
            set(val) {
                this.$emit('input', val);
            }
        }
    },
    watch: {
        dialog(val) {
            if (val) {
                this.datatransfer = { assignedUser: null, TskReasonTraslate: '' };
            }
        }
    },
    methods: {
        cancelTransfer() {
            this.dialog = false;
        },
        async sendTransfer() {
            console.log("datatransfer", this.datatransfer);
			if (!this.tasks || this.tasks.length === 0) return;
			if (!this.datatransfer.assignedUser || !this.datatransfer.assignedUser) {
				this.$fun.alert("Seleccione a qué responsable se transferirán las tareas", "warning");
				return;
			}

			const targetPrsID = this.datatransfer.assignedUser;
			
			// Validar que no se transfiera al mismo usuario en todos
			const invalidTasks = this.tasks.filter(t => t.PrsID == targetPrsID);
			if (invalidTasks.length > 0 && this.tasks.length === 1) {
				this.$fun.alert("No se puede trasladar a la misma persona", "info");
				return;
			}

			this.$fun.alert(`¿Seguro de transferir ${this.tasks.length} tarea(s)?`, "question")
				.then(async r => {
					if (r.value) {
						let successCount = 0;
						try {
							for(const task of this.tasks) {
								if (task.PrsID == targetPrsID) continue;
								
								let updatedTask = { ...task };
								updatedTask.PrsID = targetPrsID;
								updatedTask.TskReasonTraslate = this.datatransfer.TskReasonTraslate;
								updatedTask.UsrUpdateID = this.$fun.getUserID();
								
								const resp = await _sTaskService.save(updatedTask, this.$fun.getUserID());
								if (resp && resp.status == 200) {
									successCount++;
								}
							}
						} catch(e) {
							console.error(e);
						}

						if (successCount > 0) {
							this.$fun.alert(`Se transfirieron ${successCount} tareas correctamente`, "success");
							this.$emit('transferred');
							this.dialog = false;
						} else {
							this.$fun.alert("No se pudo transferir ninguna tarea (o eran para la misma persona asignada)", "warning");
						}
					}
				});
		}
    }
};
</script>
